import { render, staticRenderFns } from "./StockInvoiceRecipientIssuerData.vue?vue&type=template&id=7f7152f7&scoped=true&"
import script from "./StockInvoiceRecipientIssuerData.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceRecipientIssuerData.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceRecipientIssuerData.vue?vue&type=style&index=0&id=7f7152f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7152f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VSimpleTable,VTextField})
